"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MulticamOnboardingDialog = void 0;

var _VideoPlayer = require("../VideoPlayer");

var _react = _interopRequireWildcard(require("react"));

require("./MulticamOnboardingDialog.css");

var _ = require("../..");

var _Modal = require("../../molecules/Modal");

var _atoms = require("../../atoms");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Multicam Onboarding Dialog
var MulticamOnboardingDialog = function MulticamOnboardingDialog(_ref) {
  var videoContainerRef = _ref.videoContainerRef,
      title = _ref.title,
      firstLabel = _ref.firstLabel,
      buttonTitle = _ref.buttonTitle,
      onClose = _ref.onClose;

  var _useVideoSuspenders = (0, _VideoPlayer.useVideoSuspenders)(videoContainerRef),
      suspend = _useVideoSuspenders.suspend,
      resume = _useVideoSuspenders.resume;

  (0, _react.useEffect)(function () {
    suspend();
    return function () {
      resume(true);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    trkContext: "MulticamOnboardingDialog",
    open: true,
    className: "MulticamOnboardingDialog",
    onShadeClick: function onShadeClick() {
      return onClose();
    },
    fillScreen: false
  }, /*#__PURE__*/_react.default.createElement(_.ContentSection, {
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "banner",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_.Icon, {
    size: "112",
    color: _.Color.WarningShade,
    type: _.Icon.Type.Multicam
  })), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    paddingLeft: "8",
    paddingRight: "8"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true,
    type: _.Label.Type.Heading2,
    marginTop: "8"
  }, title), /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true,
    type: _.Label.Type.Body,
    marginTop: "4"
  }, firstLabel), /*#__PURE__*/_react.default.createElement(_.Label, {
    center: true,
    type: _.Label.Type.Body,
    marginTop: "4"
  }, "Tap the", " ", /*#__PURE__*/_react.default.createElement(_.Icon, {
    size: "16",
    color: _.Color.Black,
    type: _.Icon.Type.Multicam
  }), " ", "icon to switch between different views."))), /*#__PURE__*/_react.default.createElement(_.FooterSection, null, /*#__PURE__*/_react.default.createElement(_.Button, {
    trkAction: "Filmed in Multicam Pressed",
    primary: true,
    content: buttonTitle,
    onClick: function onClick() {
      return onClose();
    }
  })));
};

exports.MulticamOnboardingDialog = MulticamOnboardingDialog;
MulticamOnboardingDialog.defaultProps = {
  title: "Filmed in Multicam",
  firstLabel: "This game was filmed from multiple angles using TraceCam + iPhones.",
  buttonTitle: "Start watching"
};